const { validateTags } = require('./tags');
const { validateConstraints } = require('./constraints');

const ErrorCode = {
  NOT_SAVED: 'NOT_SAVED',
  IS_SAVING: 'IS_SAVING',
  INVALID_SEND_DATE: 'INVALID_SEND_DATE',
  INVALID_TAGS: 'INVALID_TAGS',
  INVALID_CONSTRAINTS: 'INVALID_CONSTRAINTS',
  EMPTY_LINK_VALUE: 'EMPTY_LINK_VALUE',
  EMPTY_IMAGE_VALUE: 'EMPTY_IMAGE_VALUE',
  EMPTY_HEADER_VALUE: 'EMPTY_HEADER_VALUE',
  EMPTY_BODY_VALUE: 'EMPTY_BODY_VALUE',
  EMPTY_BUTTON_VALUE: 'EMPTY_BUTTON_VALUE',
  INVALID_SLOT: 'INVALID_SLOT',
};

const validateConfig = (config, numberOfSlots = 2, ignoreErrors = {}) => {
  if (!ignoreErrors[ErrorCode.NOT_SAVED] && !config.isSaved) {
    const error = new Error('Config is not saved');
    error.code = ErrorCode.NOT_SAVED;
    return error;
  }

  if (config.isSaving) {
    const error = new Error('Config is being saved');
    error.code = ErrorCode.IS_SAVING;
    return error;
  }

  if(validateTags(config)) {
    const error = new Error('Invalid tags');
    error.code = ErrorCode.INVALID_TAGS;
    return error;
  }

  if (validateConstraints(config, numberOfSlots)) {
    const error = new Error('Invalid constraints');
    error.code = ErrorCode.INVALID_CONSTRAINTS;
    return error;
  }

  const notEmptyValues = ['link', 'image', 'header', 'body', 'button'];

  for (const item of config.items) {
    for (const key of notEmptyValues) {
      if (!item[key].trim()) {
        const error = new Error('Invalid empty ' + key);
        error.code = ErrorCode[`EMPTY_${key.toUpperCase()}_VALUE`];
        return error;
      }
    }
  }

  for (const item of config.items) {
    if (parseInt(item.slot, 10) !== item.slot || item.slot >= numberOfSlots || item.slot < 0) {
      const error = new Error('Invalid slot ' + item.slot);
      error.code = ErrorCode.INVALID_SLOT;
      return error;
    }
  }

  return null;
};

module.exports = { ErrorCode, validateConfig };



// WEBPACK FOOTER //
// ./common/validation/config.js